import { createFileRoute, Navigate } from '@tanstack/react-router'
import { entitledProducts, navPath } from '@bloo-team/core-shell'
import { identityFor, useSession } from '../../../lib/session'

/**
 * /settings/integrations keeps working (six years of bookmarks and the
 * legacy `/system/integrations` redirect) and lands on Catalog — or on
 * Plugins when SynthAI, which serves the catalog, is not entitled here.
 */
function IntegrationsIndex() {
  const { clusterId, scopeId } = Route.useParams()
  const session = useSession()
  if (!session) return null
  const synthai = entitledProducts(identityFor(session, clusterId, scopeId)).has('synthai')
  return <Navigate to={navPath(clusterId, scopeId, synthai ? '/settings/integrations/catalog' : '/settings/integrations/plugins')} replace />
}

export const Route = createFileRoute('/$clusterId/$scopeId/settings/integrations/')({
  component: IntegrationsIndex,
})
